import Controller from '@ember/controller';
import { action, computed, set } from '@ember/object';
import { service } from '@ember/service';
import { isPresent } from '@ember/utils';

export default Controller.extend({
  router: service(),

  invalidFileExtension: computed('model.selectedFile', function () {
    if (this.model.selectedFile) {
      return /\.csv$/.test(this.model.selectedFile.name) === false;
    } else {
      return false;
    }
  }),

  handleFileSelected: action(function (file) {
    set(this, 'model.selectedFile', file);
  }),

  startUpload: action(function () {
    if (isPresent(this.model.selectedFile) && !this.invalidFileExtension) {
      this.router.transitionTo('funds.fund.more.karani-import.processing');
    } else {
      alert('Please select a file before you start the upload.');
    }
  }),
});
